// Code generated by scripts/gen-sdk-codes from internal/errcodes; DO NOT EDIT.
// Run `task errcodes:sync` to regenerate. CI gates this file (git diff --exit-code).
//
// These are the wire `code` strings a server can put in the
// {error:{code,message}} envelope. A code outside this set is collapsed to
// "internal" by decodeError, so keeping it in step with the Go emitters is
// load-bearing (the cross-boundary-audit handoff_* finding).

export type ServerErrorCode =
  | "asset_not_found"
  | "conflict"
  | "cross_glow_token"
  | "forbidden"
  | "glow_dark"
  | "glow_not_found"
  | "handoff_expired"
  | "handoff_glow_mismatch"
  | "handoff_invalid"
  | "handoff_replay"
  | "handoff_unknown_nonce"
  | "identity_mismatch"
  | "internal"
  | "invalid_argument"
  | "invalid_asset_path"
  | "invalid_body"
  | "invalid_cursor"
  | "invalid_glow_state"
  | "invalid_handle"
  | "invalid_host"
  | "invalid_key"
  | "invalid_prefix"
  | "method_not_allowed"
  | "missing_handoff"
  | "no_live_version"
  | "not_found"
  | "payload_too_large"
  | "quota_exceeded"
  | "region_mismatch"
  | "unauthenticated"
  | "unknown_handle"
  | "unsupported_content_type"
  | "version_not_found";

export const SERVER_CODES: ReadonlySet<ServerErrorCode> = new Set([
  "asset_not_found",
  "conflict",
  "cross_glow_token",
  "forbidden",
  "glow_dark",
  "glow_not_found",
  "handoff_expired",
  "handoff_glow_mismatch",
  "handoff_invalid",
  "handoff_replay",
  "handoff_unknown_nonce",
  "identity_mismatch",
  "internal",
  "invalid_argument",
  "invalid_asset_path",
  "invalid_body",
  "invalid_cursor",
  "invalid_glow_state",
  "invalid_handle",
  "invalid_host",
  "invalid_key",
  "invalid_prefix",
  "method_not_allowed",
  "missing_handoff",
  "no_live_version",
  "not_found",
  "payload_too_large",
  "quota_exceeded",
  "region_mismatch",
  "unauthenticated",
  "unknown_handle",
  "unsupported_content_type",
  "version_not_found",
]);
